module.exports = __webpack_public_path__ + "img/checked.88298eb8.svg";